module.exports = __webpack_public_path__ + "static/media/12.32b6db16.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/12.png
// module id = 1342
// module chunks = 0